import GeneralTracker from '../GeneralTracker';


export default class ConsentScreenTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:consentScreen:interaction';
  EVENT_GROUP = 'consentScreen';
  STORAGE_KEY = 'consentScreenTrackingKey';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();
    service.on('consentScreenAccepted', this.onConsentScreenAccepted);
    service.on('consentScreenRejected', this.onConsentScreenRejected);
  }

  onConsentScreenAccepted = (payload = {}) => {
    const trackPayload = {
      action: 'acceptedConsentScreen',
      labels: { ...payload, source: 'ui' },
    };

    this.track(trackPayload);
  };

  onConsentScreenRejected = (payload = {}) => {
    const trackPayload = {
      action: 'rejectedConsentScreen',
      labels: { ...payload, source: 'ui' },
    };

    this.track(trackPayload);
  };
}
